<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nYvikh/tc-custom/9780062306418.jpg?1730584282582" alt="This image is the cover for the book Library of the Dead, Will Piper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Library of the Dead, Will Piper
      </h1>
      <p class="bookDescription body article font2">
        <p>Originally published as <i>Secret of the Seventh Son</i>.</p><p>Assigned to the high-profile "Doomsday" serial killer case, FBI agent Will Piper is hitting dead end after dead end. The victims seem to have nothing in common: age, background, or even the way they die. All that connects them is a postcard each received in the mail announcing his or her date of death—all sent from Las Vegas, where a brilliant computer scientist leads a double life. Just when agent Piper finds a credible lead, he's removed from the case. Continuing the investigation on his own, he must outwit a ruthless team of covert operatives from Area 51 protecting the government's greatest secret. From a medieval monastery to a cutting-edge government laboratory, <i>Library of the Dead</i> delivers a richly detailed, thought-provoking exploration of fate, predestination, and the choices we make in life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Glenn Cooper
      </h2>
      
      <p class="authorDescription body article"><P><B>GLENN COOPER</B>&#160;is the author of the internationally bestselling Will Piper trilogy: <I>Library of the Dead</I>, its sequel,&#160;<I>Book of Souls</I>, and&#160;<I>The Keepers of the Library.&#160;</I>His other books include&#160;<I>The Tenth Chamber</I>,&#160;<I>The Resurrection Maker</I>,&#160;<I>The Devil Will Come</I>,&#160;<I>Near Death</I>, and the Down Trilogy. He has sold over 6 million books worldwide. Glenn graduated from Harvard with a degree in archaeology and received his medical degree from Tufts University. After practicing medicine, he served as the chairman and CEO of a biotechnology company in Massachusetts. He is also a screenwriter, film producer, and chairman of Lascaux Media. Glenn lives in Sarasota, Florida. Visit him at glenncooperbooks.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?589f3802